import { render } from "./News-edit.vue?vue&type=template&id=be468ebc&scoped=true"
import script from "./News-edit.vue?vue&type=script&lang=js"
export * from "./News-edit.vue?vue&type=script&lang=js"

import "./News-edit.vue?vue&type=style&index=0&id=be468ebc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be468ebc"]])

export default __exports__